import { httpsCallable } from 'firebase/functions'
import { functions } from './firebase'
import type { UserRole } from '@/types/auth'

export interface AgreementPolicy {
  id: string
  version: string
  title: string
  role: UserRole
  markdown: string
}

export interface AgreementAcceptance {
  policyId: string
  version: string
  role: UserRole
  acceptedAt?: string
}

export interface MyAgreement {
  policy: AgreementPolicy
  acceptance?: AgreementAcceptance
  accepted: boolean
}

const call = <T>(name: string, data?: Record<string, unknown>) => {
  if (!functions) throw new Error('Firebase is not configured.')
  return httpsCallable<Record<string, unknown> | undefined, T>(functions, name)(data).then(result => result.data)
}

export const getMyAgreement = () => call<MyAgreement>('getMyAgreement')
export const acceptMyAgreement = (version: string) => call<MyAgreement>('acceptMyAgreement', { version })
